var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EntitiesTable',{attrs:{"config":_vm.config,"showDownloadCsvButton":false,"showAddButton":"","showEditButton":"","showActions":"","showDeleteButton":"","showSearch":""},scopedSlots:_vm._u([{key:"item.amount",fn:function(ref){
var item = ref.item;
return [_vm._v(" $"+_vm._s(_vm._f("dollarsAndCents")(item.amount))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }